import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
  {
    path: '/',
    name: 'FormMistico',
    component: () => import(/* webpackChunkName: "FormMistico" */ '../components/FormMistico.vue'),
    props: true
  },
  {
    path: '/carregando',
    name: 'Transition',
    component: () => import(/* webpackChunkName: "Transition" */ '../components/Transition.vue'),
    props: true
  },
  {
    path: '/es',
    name: 'FormMistico_es',
    component: () => import(/* webpackChunkName: "FormMistico" */ '../components/FormMistico_es.vue'),
    props: true
  },
  {
    path: '/fr',
    name: 'FormMistico_fr',
    component: () => import(/* webpackChunkName: "FormMistico" */ '../components/FormMistico_fr.vue'),
    props: true
  },
  {
    path: '/it',
    name: 'FormMistico_it',
    component: () => import(/* webpackChunkName: "FormMistico" */ '../components/FormMistico_it.vue'),
    props: true
  },
  {
    path: '/de',
    name: 'FormMistico_de',
    component: () => import(/* webpackChunkName: "FormMistico" */ '../components/FormMistico_de.vue'),
    props: true
  },
  {
    path: '/cargando',
    name: 'Transition_es',
    component: () => import(/* webpackChunkName: "Transition" */ '../components/Transition_es.vue'),
    props: true
  },
  {
    path: '/caricamento',
    name: 'Transition_it',
    component: () => import(/* webpackChunkName: "Transition" */ '../components/Transition_it.vue'),
    props: true
  },
  {
    path: '/chargement',
    name: 'Transition_fr',
    component: () => import(/* webpackChunkName: "Transition" */ '../components/Transition_fr.vue'),
    props: true
  },
  {
    path: '/laden',
    name: 'Transition_de',
    component: () => import(/* webpackChunkName: "Transition" */ '../components/Transition_de.vue'),
    props: true
  },
    
],
});
